import { render } from "./PasswordResetRequest.vue?vue&type=template&id=3cf59ce0&scoped=true"
import script from "./PasswordResetRequest.vue?vue&type=script&lang=js"
export * from "./PasswordResetRequest.vue?vue&type=script&lang=js"

import "./PasswordResetRequest.vue?vue&type=style&index=0&id=3cf59ce0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf59ce0"]])

export default __exports__